import React from 'react';
import preview from './fillsGraphPreview.gif';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';

export const fillsGraphDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Fills Chart visualizes your order information in real time,
                placed on top of the symbol&apos;s intraday price and volume
                chart.
            </div>
            <div>
                Beneath the primary chart are 4 supporting charts displaying
                market volumes, participation rate, P&amp;L and index relative
                price movement.
            </div>
        </>
    ),
    previews: [{ src: preview, altText: 'fills-graph-preview' }],
};
